import { render } from "./SaleTypeBadge.vue?vue&type=template&id=68e44cf0&scoped=true"
import script from "./SaleTypeBadge.vue?vue&type=script&lang=js"
export * from "./SaleTypeBadge.vue?vue&type=script&lang=js"

import "./SaleTypeBadge.vue?vue&type=style&index=0&id=68e44cf0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e44cf0"]])

export default __exports__